<template>
  <div class="analysis-page">
    <div class="analysis-header">
      <span class="header-title">{{ examinationSer }}</span>
      <div class="header-actions">
        <el-button size="small" type="primary" plain @click="secedeFunc"
          >退出测试</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="submitFunc"
          :loading="submitLoading"
          >交卷</el-button
        >
      </div>
    </div>
    <div class="page analysis-body">
      <!-- 左侧面板 -->
      <div class="left-panel">
        <div class="user-profile">
          <img class="avatar" src="@/assets/img/icontouxiang.png" />
          <div class="user-info">
            <div class="uname">
              姓名: {{ userInfo.studentName || "未命名" }}
            </div>
            <div class="uno">学号: {{ userInfo.studentNo || "0000" }}</div>
          </div>
        </div>
        <el-collapse class="nav-collapse" accordion :value="subjectType">
          <el-collapse-item name="SingX" v-if="SingXList.length > 0">
            <template slot="title">单选题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in SingXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'SingX' && subjectIndex === index,
                  answered: item.fill && item.fill.length > 0
                }"
                @click="
                  switchItem('SingX');
                  singxIndexChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="MultX" v-if="MultXList.length > 0">
            <template slot="title">多选题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in MultXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'MultX' && subjectIndex === index,
                  answered: item.correctOrder && item.correctOrder.length > 0
                }"
                @click="
                  switchItem('MultX');
                  multxIndexChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="JudgX" v-if="JudgXList.length > 0">
            <template slot="title">判断题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in JudgXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'JudgX' && subjectIndex === index,
                  answered: item.order !== undefined
                }"
                @click="
                  switchItem('JudgX');
                  judgexIndexChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="FillX" v-if="FillXList.length > 0">
            <template slot="title">填空题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in FillXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'FillX' && subjectIndex === index,
                  answered:
                    item.answer ||
                    (attachments[item.qid] && attachments[item.qid].length > 0)
                }"
                @click="
                  switchItem('FillX');
                  fillxChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="AnwsX" v-if="AnwsXList.length > 0">
            <template slot="title">解答题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in AnwsXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'AnwsX' && subjectIndex === index,
                  answered:
                    item.answer ||
                    (attachments[item.qid] && attachments[item.qid].length > 0)
                }"
                @click="
                  switchItem('AnwsX');
                  anwsxChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="ProofX" v-if="ProofXList.length > 0">
            <template slot="title">证明题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in ProofXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'ProofX' && subjectIndex === index,
                  answered:
                    item.answer ||
                    (attachments[item.qid] && attachments[item.qid].length > 0)
                }"
                @click="
                  switchItem('ProofX');
                  proofxChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!-- 右侧题目区域 -->
      <div class="right">
        <div class="item" :key="subjectType + '-' + subjectIndex">
          <!-- 单选 -->
          <div
            class="title"
            v-if="subjectType === 'SingX' && SingXList.length > 0"
          >
            <div v-for="(item, idx) in currentQuestion.steam" :key="idx">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <div
            class="groupbox"
            v-if="subjectType === 'SingX' && SingXList.length > 0"
          >
            <el-radio-group
              v-model="currentQuestion.fill"
              class="el_radio_group"
              @change="radioChange($event)"
            >
              <div
                v-for="(item, index) in currentQuestion.options"
                :key="index"
                class="option-row"
                @click="anwser(item, currentQuestion)"
              >
                <el-radio :label="orderList[index].label" class="el_radio">
                  <div class="option-wrapper">
                    <span
                      class="custom-checkbox"
                      :class="{
                        'is-checked':
                          currentQuestion.fill === orderList[index].label
                      }"
                    ></span>
                    <span class="labelbox">{{ orderList[index].label }}</span>
                    <span class="option-content">
                      <span v-for="(t, i) in item.ranginfos" :key="i">
                        <span v-for="(it, j) in t.wordInfos" :key="j">
                          <span v-if="it.wdType === 1" v-katex
                            >${{ it.latex }}$</span
                          >
                          <img v-else-if="it.wdType === 2" :src="it.buffer" />
                          <span v-else>{{ it.content }}</span>
                        </span>
                      </span>
                    </span>
                  </div>
                </el-radio>
              </div>
            </el-radio-group>
          </div>
          <!-- 多选 -->
          <div
            class="title"
            v-if="subjectType === 'MultX' && MultXList.length > 0"
          >
            <div v-for="(item, idx) in currentQuestion.steam" :key="idx">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <div
            class="groupcheckbox"
            v-if="subjectType === 'MultX' && MultXList.length > 0"
          >
            <el-checkbox-group
              v-model="currentQuestion.correctOrder"
              class="el_radio_group"
              @change="MultXListChange(currentQuestion)"
            >
              <div
                v-for="(item, index) in currentQuestion.options"
                :key="index"
                class="option-row"
              >
                <el-checkbox :label="item.index" class="el_radio">
                  <div class="option-wrapper">
                    <span
                      class="custom-checkbox"
                      :class="{
                        'is-checked':
                          currentQuestion.correctOrder &&
                          currentQuestion.correctOrder.includes(item.index)
                      }"
                    ></span>
                    <span class="labelbox">{{ orderList[index].label }}</span>
                    <span class="option-content">
                      <span v-for="(t, i) in item.ranginfos" :key="i">
                        <span v-for="(it, j) in t.wordInfos" :key="j">
                          <span v-if="it.wdType === 1" v-katex
                            >${{ it.latex }}$</span
                          >
                          <img v-else-if="it.wdType === 2" :src="it.buffer" />
                          <span v-else>{{ it.content }}</span>
                        </span>
                      </span>
                    </span>
                  </div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
          <!-- 判断 -->
          <div
            class="title"
            v-if="subjectType === 'JudgX' && JudgXList.length > 0"
          >
            <div v-for="item in currentQuestion.steam" :key="item.id">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <div v-if="subjectType === 'JudgX' && JudgXList.length > 0">
            <el-radio-group
              v-model="currentQuestion.order"
              class="el_radio_group"
              @change="judgxListChange(currentQuestion)"
            >
              <el-radio :label="1" class="el_radio">
                <span class="box"><i class="el-icon-circle-check"></i></span>
              </el-radio>
              <br />
              <el-radio :label="0" class="el_radio">
                <span class="box"><i class="el-icon-circle-close"></i></span>
              </el-radio>
            </el-radio-group>
          </div>
          <!-- 填空 -->
          <div
            class="title"
            v-if="subjectType === 'FillX' && FillXList.length > 0"
          >
            <div v-for="(item, idx) in currentQuestion.steam" :key="idx">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 填空题附件上传 -->
          <div
            v-if="subjectType === 'FillX' && FillXList.length > 0"
            class="attachment-container"
          >
            <div class="attachment-header">
              <i class="el-icon-picture"></i>
              <span>答题附件 (填空题)</span>
            </div>
            <div class="attachment-list">
              <div
                v-for="(file, index) in getAttachmentsByQid(
                  currentQuestion.qid
                )"
                :key="index"
                class="attachment-item"
              >
                <el-image
                  :src="file.url"
                  :preview-src-list="
                    getAttachmentsByQid(currentQuestion.qid).map(v => v.url)
                  "
                  fit="cover"
                ></el-image>
                <i
                  v-if="analysis == 0"
                  class="el-icon-delete delete-btn"
                  @click="handleAttachmentDelete(file, currentQuestion)"
                ></i>
              </div>
              <el-upload
                v-if="analysis == 0"
                action=""
                :auto-upload="false"
                :on-change="
                  file => handleAttachmentUpload(file, currentQuestion)
                "
                :show-file-list="false"
                accept="image/*"
              >
                <div class="upload-trigger">
                  <i class="el-icon-plus"></i>
                  <span>添加图片</span>
                </div>
              </el-upload>
            </div>
          </div>
          <!-- 解答 -->
          <div
            class="title"
            v-if="subjectType === 'AnwsX' && AnwsXList.length > 0"
          >
            <div v-for="(item, idx) in currentQuestion.steam" :key="idx">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 解答题附件上传 -->
          <div
            v-if="subjectType === 'AnwsX' && AnwsXList.length > 0"
            class="attachment-container"
          >
            <div class="attachment-header">
              <i class="el-icon-picture"></i>
              <span>答题附件 (解答题)</span>
            </div>
            <div class="attachment-list">
              <div
                v-for="(file, index) in getAttachmentsByQid(
                  currentQuestion.qid
                )"
                :key="index"
                class="attachment-item"
              >
                <el-image
                  :src="file.url"
                  :preview-src-list="
                    getAttachmentsByQid(currentQuestion.qid).map(v => v.url)
                  "
                  fit="cover"
                ></el-image>
                <i
                  v-if="analysis == 0"
                  class="el-icon-delete delete-btn"
                  @click="handleAttachmentDelete(file, currentQuestion)"
                ></i>
              </div>
              <el-upload
                v-if="analysis == 0"
                action=""
                :auto-upload="false"
                :on-change="
                  file => handleAttachmentUpload(file, currentQuestion)
                "
                :show-file-list="false"
                accept="image/*"
              >
                <div class="upload-trigger">
                  <i class="el-icon-plus"></i>
                  <span>添加图片</span>
                </div>
              </el-upload>
            </div>
          </div>
          <!-- 证明 -->
          <div
            class="title"
            v-if="subjectType === 'ProofX' && ProofXList.length > 0"
          >
            <div v-for="(item, idx) in currentQuestion.steam" :key="idx">
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 证明题附件上传 -->
          <div
            v-if="subjectType === 'ProofX' && ProofXList.length > 0"
            class="attachment-container"
          >
            <div class="attachment-header">
              <i class="el-icon-picture"></i>
              <span>答题附件 (证明题)</span>
            </div>
            <div class="attachment-list">
              <div
                v-for="(file, index) in getAttachmentsByQid(
                  currentQuestion.qid
                )"
                :key="index"
                class="attachment-item"
              >
                <el-image
                  :src="file.url"
                  :preview-src-list="
                    getAttachmentsByQid(currentQuestion.qid).map(v => v.url)
                  "
                  fit="cover"
                ></el-image>
                <i
                  v-if="analysis == 0"
                  class="el-icon-delete delete-btn"
                  @click="handleAttachmentDelete(file, currentQuestion)"
                ></i>
              </div>
              <el-upload
                v-if="analysis == 0"
                action=""
                :auto-upload="false"
                :on-change="
                  file => handleAttachmentUpload(file, currentQuestion)
                "
                :show-file-list="false"
                accept="image/*"
              >
                <div class="upload-trigger">
                  <i class="el-icon-plus"></i>
                  <span>添加图片</span>
                </div>
              </el-upload>
            </div>
          </div>
          <!-- 底部翻页 -->
          <div class="bottom-nav">
            <el-button class="last" @click="last" type="primary"
              >上一题</el-button
            >
            <div class="line">|</div>
            <el-button class="next" @click="next" type="primary"
              >下一题</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getStudentInfo,
  getOwnTeachingTaskDetail,
  submitTeachingTask,
  uploadFile,
  addUserPaperPhotoRecord,
  delUserPaperPhotoRecord,
  getUserPaperPhotoRecord
} from "@/api/student";
import { convertToFullQuestion } from "@/util/extraction.js";

export default {
  name: "workTest",
  components: {},
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo") || "{}"),
      examinationSer: "",
      taskId: "",
      resultList: [],
      str: "\u3000",
      SingXList: [],
      MultXList: [],
      JudgXList: [],
      ProofXList: [],
      FillXList: [],
      AnwsXList: [],
      subjectType: "SingX",
      subjectIndex: 0,
      currentQuestion: {},
      orderList: [
        { value: 0, label: "A" },
        { value: 1, label: "B" },
        { value: 2, label: "C" },
        { value: 3, label: "D" },
        { value: 4, label: "E" },
        { value: 5, label: "F" },
        { value: 6, label: "G" },
        { value: 7, label: "H" },
        { value: 8, label: "I" }
      ],
      choose: {},
      submitLoading: false,
      attachments: {}, // { qid: [fileList] }
      loadingAttachments: false,
      analysis: 0
    };
  },
  watch: {
    "currentQuestion.qid"(newVal) {
      if (newVal) {
        this.loadQuestionAttachments(newVal);
      }
    }
  },
  async mounted() {
    // 在即将离开当前页面时执行
    window.onbeforeunload = function() {
      return "quit?";
    };

    this.examinationSer = this.$route.query.title || "";
    this.analysis = this.$route.query.analysis || 0;
    this.taskId = this.$route.params.taskId || this.$route.params.id;
    localStorage.setItem("taskId", this.taskId);

    await this.getDetail();
    this.firstFunc();
  },
  methods: {
    async getDetail() {
      // 获取用户信息用于展示
      getStudentInfo().then(res => {
        if (res.code === 200 && res.data) {
          const name = res.data.userName || res.data.studentName;
          const no = res.data.studentNo || res.data.userNumber;
          this.userInfo = {
            ...this.userInfo,
            studentName: name,
            studentNo: no
          };
        }
      });

      // 从 localStorage 获取 studentId
      const studentId = JSON.parse(localStorage.getItem("userInfo") || "{}")
        .studentId;

      const res = await getOwnTeachingTaskDetail({
        studentId,
        taskId: this.taskId
      });
      // 处理 responseType 为 text 时返回的字符串
      let result = res;
      if (typeof res === "string") {
        try {
          result = JSON.parse(res);
        } catch (e) {
          console.error("JSON 解析失败:", e);
          this.$message.error("题目加载失败，请返回重试");
          return;
        }
      }
      console.log("=== getOwnTeachingTaskDetail 调试 ===");
      console.log("请求参数:", { studentId, taskId: this.taskId });
      console.log("原始返回类型:", typeof res);
      console.log("解析后结果:", result);
      if (result.code !== 200 || !result.data || !result.data.length) {
        console.error("题目加载失败条件触发:", {
          code: result.code,
          hasData: !!result.data,
          dataLength: result.data ? result.data.length : "N/A"
        });
        this.$message.error("题目加载失败，请返回重试");
        return;
      }

      const list = [];
      result.data.forEach(val => {
        list.push(val.teachingTaskDetail);
        this.resultList.push(val.studentResult);
      });

      const arr = list.map(item => convertToFullQuestion(item));
      this.filterArray(arr);
    },
    filterArray(arr) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      let arr1 = [];
      arr.forEach(item => {
        arr1.push(item);
      });

      arr1.filter(item => {
        this.choose = [];
        // 还原答案顺序
        let result = this.resultList;
        result.forEach(s => {
          if (s.questionId == item.qid) {
            if (item.subjectType == "SingX" || item.subjectType == "MultX") {
              let orgoptions = item.options;
              item.options = [];
              for (let n = 0; n < s.answerSequences.length; n++) {
                let optid = s.answerSequences[n];
                orgoptions.forEach(optitem => {
                  if (optitem.index == optid) {
                    item.options.push(optitem);
                  }
                });
              }
              item.order = s.answerSequences;
              if (item.subjectType == "MultX") {
                item.answer = s.result ? s.result.split(",") : [];
              } else {
                item.answer = s.result;
              }
            }
            if (item.subjectType == "JudgX") {
              if (s.result === "0") {
                item.answer = "错误";
              } else if (s.result === "1") {
                item.answer = "正确";
              } else {
                item.answer = "";
              }
            }
          }
        });

        item.usr_choice = item.answer;
        if (item.subjectType == "SingX") {
          item.fill = ""; // 初始化选择
          let pindex = parseInt(item.answer);
          item.options.forEach((opt, index) => {
            if (opt.index === pindex) {
              switch (index) {
                case 0:
                  item.answer = "A";
                  item.fill = "A";
                  break;
                case 1:
                  item.answer = "B";
                  item.fill = "B";
                  break;
                case 2:
                  item.answer = "C";
                  item.fill = "C";
                  break;
                case 3:
                  item.answer = "D";
                  item.fill = "D";
                  break;
                case 4:
                  item.answer = "E";
                  item.fill = "E";
                  break;
                case 5:
                  item.answer = "F";
                  item.fill = "F";
                  break;
                case 6:
                  item.answer = "G";
                  item.fill = "G";
                  break;
                case 7:
                  item.answer = "H";
                  item.fill = "H";
                  break;
                default:
                  break;
              }
            }
          });
        }
        if (item.subjectType == "MultX") {
          item.fill = "";
          item.correctOrder = []; // 初始化多选
          item.options.forEach(opt => {
            opt.hh = false;
          });
          if (item.answer && item.answer.map) {
            item.answer.map(val => {
              let pindex = parseInt(val);
              item.options.forEach((opt, index) => {
                if (opt.index === pindex) {
                  opt.hh = true;
                  item.correctOrder.push(opt.index);
                  switch (index) {
                    case 0:
                      item.fill = item.fill.concat("A");
                      break;
                    case 1:
                      item.fill = item.fill.concat("B");
                      break;
                    case 2:
                      item.fill = item.fill.concat("C");
                      break;
                    case 3:
                      item.fill = item.fill.concat("D");
                      break;
                    case 4:
                      item.fill = item.fill.concat("E");
                      break;
                    case 5:
                      item.fill = item.fill.concat("F");
                      break;
                    case 6:
                      item.fill = item.fill.concat("G");
                      break;
                    case 7:
                      item.fill = item.fill.concat("H");
                      break;
                    default:
                      break;
                  }
                }
              });
            });
          }
        }
      });

      this.SingXList = arr1.filter(item => item.subjectType === "SingX");
      this.MultXList = arr1.filter(item => item.subjectType === "MultX");
      this.JudgXList = arr1.filter(item => item.subjectType === "JudgX");
      this.ProofXList = arr1.filter(item => item.subjectType === "ProofX");
      this.FillXList = arr1.filter(item => item.subjectType === "FillX");
      this.AnwsXList = arr1.filter(item => item.subjectType === "AnwsX");

      this.$nextTick(() => {
        this.setImageWidth();
      });
      loading.close();
    },
    // 默认展示第一个有题目的题型
    firstFunc() {
      if (this.SingXList.length > 0) {
        this.subjectType = "SingX";
        this.subjectIndex = 0;
        this.singxIndexChange(0);
        return;
      }
      if (this.MultXList.length > 0) {
        this.subjectType = "MultX";
        this.subjectIndex = 0;
        this.multxIndexChange(0);
        return;
      }
      if (this.JudgXList.length > 0) {
        this.subjectType = "JudgX";
        this.subjectIndex = 0;
        this.judgexIndexChange(0);
        return;
      }
      if (this.FillXList.length > 0) {
        this.subjectType = "FillX";
        this.subjectIndex = 0;
        this.fillxChange(0);
        return;
      }
      if (this.AnwsXList.length > 0) {
        this.subjectType = "AnwsX";
        this.subjectIndex = 0;
        this.anwsxChange(0);
        return;
      }
      if (this.ProofXList.length > 0) {
        this.subjectType = "ProofX";
        this.subjectIndex = 0;
        this.proofxChange(0);
      }
    },
    switchItem(type) {
      this.subjectType = type;
      this.subjectIndex = 0;
    },
    // 单选处理
    singxIndexChange(index) {
      this.subjectIndex = index;
      let item = this.SingXList[this.subjectIndex];
      // 构建 orders 数组
      let arr = item.options;
      let arr1 = arr.map(opt =>
        opt.index !== undefined ? opt.index : opt.opsindex || 0
      );
      item.orders = arr1;

      this.currentQuestion = {};
      this.$nextTick(() => {
        this.currentQuestion = item;
      });
    },
    // 多选处理
    multxIndexChange(index) {
      this.subjectIndex = index;
      let item = this.MultXList[this.subjectIndex];
      // 构建 orders 数组
      let arr = item.options;
      let arr1 = arr.map(opt =>
        opt.index !== undefined ? opt.index : opt.opsindex || 0
      );
      item.orders = arr1;

      this.currentQuestion = {};
      this.$nextTick(() => {
        this.currentQuestion = item;
      });
    },
    // 判断处理
    judgexIndexChange(index) {
      this.subjectIndex = index;
      let item = this.JudgXList[this.subjectIndex];

      this.currentQuestion = {};
      this.$nextTick(() => {
        this.currentQuestion = item;
      });
    },
    fillxChange(index) {
      this.subjectIndex = index;
      this.currentQuestion = {};
      this.$nextTick(() => {
        this.currentQuestion = this.FillXList[this.subjectIndex];
      });
    },
    proofxChange(index) {
      this.subjectIndex = index;
      this.currentQuestion = {};
      this.$nextTick(() => {
        this.currentQuestion = this.ProofXList[this.subjectIndex];
      });
    },
    anwsxChange(index) {
      this.subjectIndex = index;
      this.currentQuestion = {};
      this.$nextTick(() => {
        this.currentQuestion = this.AnwsXList[this.subjectIndex];
      });
    },
    // 单选选择答案
    anwser(item, question) {
      this.resultList.forEach(val => {
        if (val.questionId === question.qid) {
          val.result = item.index;
        }
      });
    },
    radioChange() {
      // 单选变化处理
    },
    // 判断选择答案
    judgxListChange(item) {
      this.resultList.forEach(val => {
        if (val.questionId === item.qid) {
          val.result = item.order;
        }
      });
    },
    // 多选变化
    MultXListChange(value) {
      this.resultList.forEach(val => {
        if (val.questionId === value.qid) {
          val.result = value.correctOrder ? value.correctOrder.join(",") : "";
        }
      });
    },
    // 上一题
    last() {
      if (this.subjectIndex === 0) return;
      this.subjectIndex--;
      this.updateCurrentQuestion();
    },
    // 下一题
    next() {
      let maxIdx = 0;
      if (this.subjectType === "SingX") maxIdx = this.SingXList.length - 1;
      else if (this.subjectType === "MultX") maxIdx = this.MultXList.length - 1;
      else if (this.subjectType === "JudgX") maxIdx = this.JudgXList.length - 1;
      else if (this.subjectType === "FillX") maxIdx = this.FillXList.length - 1;
      else if (this.subjectType === "ProofX")
        maxIdx = this.ProofXList.length - 1;
      else if (this.subjectType === "AnwsX") maxIdx = this.AnwsXList.length - 1;
      if (this.subjectIndex < maxIdx) {
        this.subjectIndex++;
        this.updateCurrentQuestion();
      }
    },
    updateCurrentQuestion() {
      if (this.subjectType === "SingX")
        this.singxIndexChange(this.subjectIndex);
      else if (this.subjectType === "MultX")
        this.multxIndexChange(this.subjectIndex);
      else if (this.subjectType === "JudgX")
        this.judgexIndexChange(this.subjectIndex);
      else if (this.subjectType === "FillX")
        this.fillxChange(this.subjectIndex);
      else if (this.subjectType === "ProofX")
        this.proofxChange(this.subjectIndex);
      else if (this.subjectType === "AnwsX")
        this.anwsxChange(this.subjectIndex);
    },
    // 退出测试
    secedeFunc() {
      this.$router.go(-1);
    },
    // 交卷
    submitFunc() {
      this.$confirm("确定要交卷吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.submitLoading = true;
          let data = {
            picUrls: "",
            resultList: this.resultList,
            studentId: JSON.parse(localStorage.getItem("userInfo")).studentId,
            taskId: localStorage.getItem("taskId")
          };
          submitTeachingTask(data)
            .then(res => {
              this.submitLoading = false;
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "提交成功!"
                });
                window.onbeforeunload = null;
                this.$router.go(-1);
              } else {
                this.$message.error(res.msg || "提交失败");
              }
            })
            .catch(() => {
              this.submitLoading = false;
              this.$message.error("提交失败，请重试");
            });
        })
        .catch(() => {});
    },
    setImageWidth() {
      let imgs = document.getElementsByTagName("img");
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].className == "subjectImage") {
          imgs[i].style.zoom = "50%";
        }
      }
    },
    // 加载当前题目的附件
    async loadQuestionAttachments(qid) {
      if (!qid || this.loadingAttachments) return;
      this.loadingAttachments = true;
      try {
        const studentId = Number(
          sessionStorage.getItem("studentID") ||
            localStorage.getItem("studentID") ||
            (this.userInfo && (this.userInfo.studentId || this.userInfo.id))
        );
        console.log(
          "Loading attachments for qid:",
          qid,
          " studentId:",
          studentId
        );

        const res = await getUserPaperPhotoRecord(
          Number(this.taskId),
          Number(qid),
          studentId
        );
        console.log("Load attachments response:", res);
        if (res.code === 200) {
          this.$set(this.attachments, qid, res.data || []);
        }
      } catch (e) {
        console.error("加载附件记录失败:", e);
      } finally {
        this.loadingAttachments = false;
      }
    },
    // 处理图片上传
    async handleAttachmentUpload(file, question) {
      if (!file || !question) return;

      try {
        const uploadRes = await uploadFile(file.raw);
        if (uploadRes.code === 200 && uploadRes.data) {
          // 提交到后端记录同步
          const studentId = Number(
            sessionStorage.getItem("studentID") ||
              localStorage.getItem("studentID") ||
              (this.userInfo && (this.userInfo.studentId || this.userInfo.id))
          );
          const recordData = {
            paperID: Number(this.taskId),
            questionID: Number(question.qid),
            userID: studentId,
            url: uploadRes.data
          };
          console.log("Saving attachment record:", recordData);

          await addUserPaperPhotoRecord(recordData);
          this.$message.success("附件上传成功");

          // 更新本地题目答案状态，标记为已答
          if (!question.answer || !question.answer.includes("[已上传附件]")) {
            question.answer = (question.answer || "") + "[已上传附件]";
            this.resultList.forEach(val => {
              if (val.questionId === question.qid) {
                val.result = question.answer;
              }
            });
          }

          // 重新加载该题的附件列表
          await this.loadQuestionAttachments(question.qid);
        } else {
          this.$message.error("文件上传失败，请稍后重试");
        }
      } catch (err) {
        console.error("上传错误:", err);
        this.$message.error("附件上传出错");
      }
    },
    // 处理删除
    async handleAttachmentDelete(file, question) {
      this.$confirm("确定要删除该附件吗？", "提示").then(async () => {
        try {
          const res = await delUserPaperPhotoRecord(file.id);
          if (res.code === 200) {
            this.$message.success("附件已删除");
            const newList = this.getAttachmentsByQid(question.qid).filter(
              item => item.id !== file.id
            );
            this.$set(this.attachments, question.qid, newList);

            // 如果附件全部删除，同步清除本地答案状态
            if (newList.length === 0 && question.answer === "[已上传附件]") {
              question.answer = "";
              this.resultList.forEach(val => {
                if (val.questionId === question.qid) {
                  val.result = "";
                }
              });
            }
          }
        } catch (error) {
          this.$message.error("删除失败");
        }
      });
    },
    // 切换题目时加载附件
    afterCurrentQuestionUpdate() {
      if (this.currentQuestion && this.currentQuestion.qid) {
        this.loadQuestionAttachments(this.currentQuestion.qid);
      }
    },
    // 安全获取附件列表
    getAttachmentsByQid(qid) {
      if (!qid) return [];
      return this.attachments[qid] || [];
    }
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  }
};
</script>

<style lang="scss" scoped>
.analysis-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: white;
  min-height: 100vh;
}

.analysis-header {
  height: 60px;
  border-bottom: 2px solid #f8fafb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  background: white;

  .header-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }

  .header-actions {
    display: flex;
    gap: 10px;
  }
}

.page {
  display: flex;
}

.analysis-body {
  flex: 1;
  display: flex;
  gap: 20px;
  background: #f5f7fa !important;
  padding: 20px !important;
  box-shadow: none !important;

  .left-panel {
    width: 280px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .user-profile {
      padding: 20px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ebeef5;

      .avatar {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-right: 15px;
        object-fit: cover;
      }

      .user-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .uname {
          font-size: 16px;
          font-weight: 500;
          color: #303133;
          margin-bottom: 6px;
        }
        .uno {
          font-size: 13px;
          color: #909399;
        }
      }
    }

    .nav-collapse {
      flex: 1;
      overflow-y: auto;
      border-top: none;
      padding: 0 10px;

      ::v-deep .el-collapse-item__header {
        font-size: 15px;
        font-weight: 500;
        color: #303133;
        padding-left: 10px;
      }
      ::v-deep .el-collapse-item__wrap {
        border-bottom: none;
      }

      .nav-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding: 10px;

        .nav-circle {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #f4f4f5;
          color: #606266;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            color: #409eff;
            background: #ecf5ff;
          }

          &.answered {
            background: #f0f9eb;
            color: #67c23a;
          }

          &.active {
            background: #409eff;
            color: white;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.4);
          }
        }
      }
    }
  }

  .right {
    flex: 1;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    padding: 30px;
    margin: 0 !important;
    width: auto !important;
    text-align: left;

    .item {
      padding: 0 !important;
      height: auto !important;
      min-height: 200px;

      .title {
        font-size: 24px;
        margin-bottom: 20px;

        img {
          vertical-align: middle;
        }
      }

      .groupbox,
      .groupcheckbox {
        font-size: 20px;
      }
    }
  }
}

.bottom-nav {
  margin-top: 60px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  .last,
  .next {
    margin: 0 60px;
    cursor: pointer;
  }

  .line {
    color: #eee;
    margin: 0 10px;
  }
}

.labelbox {
  margin-left: 8px;
  margin-right: 12px;
  font-weight: 500;
}

.option-row {
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 4px;
  margin-bottom: 8px;

  &:hover {
    background-color: #f5f7fa;
  }
}

.option-wrapper {
  display: flex;
  align-items: center;
  font-size: 20px;
}

.custom-checkbox {
  width: 20px;
  height: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  display: inline-block;
  position: relative;
  background-color: #fff;
  transition: all 0.2s;
  flex-shrink: 0;

  &.is-checked {
    background-color: #409eff;
    border-color: #409eff;

    &::after {
      content: "";
      position: absolute;
      left: 6px;
      top: 2px;
      width: 5px;
      height: 10px;
      border: solid #fff;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
}

.option-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  line-height: 1.5;
}

.labelbox1 {
  margin-left: 10px;
}

.box {
  font-size: 40px;
}

::v-deep .el_radio_group {
  font-size: 26px;
  flex-wrap: wrap;
  overflow-x: hidden;
  width: 100%;
  .el_radio,
  .el-checkbox {
    position: relative;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    width: 100%;
    margin-right: 0;
    white-space: normal;

    .el-radio__input,
    .el-checkbox__input {
      display: none; // 隐藏原始单选/多选框
    }

    .el-radio__label,
    .el-checkbox__label {
      padding-left: 0;
      width: 100%;
    }
  }
}

::v-deep .groupbox .el-radio .el-radio__input {
  width: 40px;
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
::v-deep .el-radio .el-radio__input:hover {
  border-color: #409eff;
}
::v-deep .el_radio_group .el-radio__label {
  font-size: 20px;
}
::v-deep .el-radio__inner {
  border: 0;
  width: 0;
  height: 0;
}
::v-deep .el-checkbox .el-checkbox__input {
  width: 40px;
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
::v-deep .el-checkbox .el-checkbox__input:hover {
  border-color: #409eff;
}
::v-deep .el-checkbox .el-checkbox__inner {
  border: 0;
  width: 0;
  height: 0;
}
::v-deep .el-checkbox__label {
  font-size: 20px;
  width: 80%;
}

::v-deep .el-icon-circle-close:hover {
  color: #409eff;
}

::v-deep .el-icon-circle-check:hover {
  color: #409eff;
}

::v-deep .katex {
  font-size: 24px;
}

.attachment-container {
  margin-top: 20px;
  width: 100%;
  padding: 15px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;

  .attachment-header {
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 600;
    color: #334155;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .attachment-list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }

  .attachment-item {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #cbd5e1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .el-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
    }

    .delete-btn {
      position: absolute;
      top: 5px;
      right: 5px;
      padding: 4px;
      background: rgba(239, 68, 68, 0.9);
      color: #fff;
      border-radius: 50%;
      cursor: pointer;
      display: none;
      font-size: 14px;
      z-index: 10;
      width: 24px;
      height: 24px;
      align-items: center;
      justify-content: center;
    }

    &:hover .delete-btn {
      display: flex;
    }
  }

  .upload-trigger {
    width: 120px;
    height: 120px;
    border: 1px dashed #cbd5e1;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #fff;
    transition: all 0.3s;

    &:hover {
      border-color: #3b82f6;
      color: #3b82f6;
      background: #eff6ff;
    }

    i {
      font-size: 24px;
      margin-bottom: 5px;
    }

    span {
      font-size: 13px;
    }
  }
}

.upload-btn {
  margin-top: 10px;
}
</style>
